import { Tutor } from "src/services/tutorsService";

// Helper functions to work with tutor data
export const getTutorName = (tutor: Tutor): string => 
  `${tutor.first_name} ${tutor.last_name}`;

export const getTutorPhoto = (tutor: Tutor): string => {
  return tutor.profile_picture_url || 
    `https://ui-avatars.com/api/?name=${encodeURIComponent(getTutorName(tutor))}&background=6366f1&color=fff&size=256`;
};

export const getTutorSpecialties = (tutor: Tutor): string[] => {
  const subjects = tutor.subjects_taught || [];
  const expertise = tutor.expertise || [];
  return [...subjects, ...expertise];
};

export const getTutorExperience = (tutor: Tutor): string => {
  if (tutor.total_years_exp) {
    return `${tutor.total_years_exp} years of experience`;
  }
  return "Experience not specified";
};

export const getTutorLocation = (tutor: Tutor): string => {
  if (tutor.timezone) {
    return `Remote / ${tutor.timezone}`;
  }
  return "Remote";
};

export const getTutorInitials = (tutor: Tutor): string => {
  const name = getTutorName(tutor);
  return name.split(' ').map(n => n[0]).join('').toUpperCase();
};